module.exports = __webpack_public_path__ + "img/05.f59294d1.png";